import { render, staticRenderFns } from "./SmallPagination.vue?vue&type=template&id=a8ae85f0&"
import script from "./SmallPagination.vue?vue&type=script&lang=js&"
export * from "./SmallPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports